const trackingDetails = {
  csat: {
    cancelSurvey: (displayName: string) =>
      `${displayName} Survey Feedback Cancelled`,
    displaySurveyButtonClicked: (displayName: string) =>
      `${displayName} Display Survey Button Clicked`,
    submitSurvey: (displayName: string) =>
      `${displayName} Survey Feedback Submitted`,
  },
  wiseOwl: {
    buttonActionClicked: (displayName: string, buttonText: string) =>
      `${displayName} ${buttonText} Button Action Clicked`,
    cancelNegativeFeedback: (displayName: string) =>
      `${displayName} Cancel Negative Feedback Submission Clicked`,
    chatCreated: (displayName: string) => `${displayName} Message Created`,
    feedbackLogin: (displayName: string) => `${displayName} Feedback Login`,
    linkClicked: (displayName: string) => `${displayName} Link Clicked`,
    messageSent: (displayName: string) => `${displayName} Message Sent`,
    negativeFeedbackClicked: (displayName: string) =>
      `${displayName} Negative Feedback Clicked`,
    negativeFeedbackSent: (displayName: string) =>
      `${displayName} Negative Feedback Sent`,
    positiveFeedbackClicked: (displayName: string) =>
      `${displayName} Positive Feedback Clicked`,
    positiveFeedbackSent: (displayName: string) =>
      `${displayName} Positive Feedback Sent`,
    promptSuggestionClicked: (displayName: string) =>
      `${displayName} Prompt Suggestion Clicked`,
    comboboxButtonClicked: (
      displayName: string,
      isSubmit: boolean,
      comboboxText: string
    ) =>
      `${displayName} Combobox ${
        isSubmit ? "submit" : "cancel"
      } Button Clicked ${isSubmit ? `with item: ${comboboxText}` : ""}`,
    homeInsightClicked: (displayName: string) =>
      `${displayName} Home Insight Clicked`,
    viewMoreHomeInsightsClicked: (displayName: string) =>
      `${displayName} View More Home Insights Clicked`,
  },
};

export { trackingDetails };
